export default __webpack_public_path__ + "static/media/portfolio-70.bf7b6acb.jpg";